export class BRoute {

    private label: string;
    private link: string;

    constructor(label: string, link?: string) {
        this.label = label;
        this.link = link ?  link : '';
    }

    public get Label() {
        return this.label;
    }

    public get Link() {
        return this.link;
    }

    public set Label(label) {
        this.label = label;
    }

    public set Link(link) {
        this.link = link;
    }
}
